import {Api} from "./api"

export default class AlertRuleApi extends Api {
    constructor() {
        super("/alertRule");
    }

    async getAlertRules(AlertID: number) {
        return await this.call("/list_alertRule", {AlertID})
    }

    async addAlertRule(alertID: number, TimeThreshold: number, CountThreshold: number, TimeType: number, ResetLevel: number) {
        return await this.call("/add_alertRule", {alertID, TimeThreshold, CountThreshold, TimeType, ResetLevel});
    }

    async deleteAlertRule(alertRuleID: number) {
        return await this.call("/delete_alertRule", {alertRuleID});
    }

    async updateAlertRule(alertID: number, alertRules: any) {
        return await this.call("/update_alertRule", {alertID, alertRules});

    }
}